import { formatDate, parseDate } from '../common/utils';
import { pathOr } from 'rambda';
import { flow } from 'fp-ts/function';

export const showExpDate = flow(
  pathOr(null, 'expirationDate'),
  parseDate,
  formatDate
);
